import { makeStyles } from '@material-ui/core/styles';
import NotificationHead from '../../../../components/Home/Notification/notificationHead';
import { i18n } from '../../../../language';
import { getArrayRandomKey } from '../../../../utils';
import WardStaff from './wardstaff';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0',
    position: 'fixed',
    top: '4.375rem',
    right: 0,
    bottom: '0',
    width: '19.438rem',
    height: 'calc(100vh-4.375rem)',
    backgroundColor: theme.palette.font.white,
    boxShadow: '0 0 0.75rem 0 #d2d7e0',
  },
  head: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.336rem',
    fontWeight: '500',
    padding: '1.25rem 0 1.188rem 1.125rem',
  },
  list: {
    overflowY: 'hidden',
    height: 'calc(100% - 5.563rem)',
    padding: '1.188rem 0 0 1.313rem',
    '&:hover': {
      overflowY: 'auto',
    },
  },
}));

export default function WardstaffList({ wardStaffdata }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <NotificationHead head={i18n.t('EHANDOVER_WARD_STAFF_LIST')} className={classes.head} />
      <div className={classes.list}>
        {wardStaffdata.map((item, index) => (
          <WardStaff key={getArrayRandomKey(index, item?.id)} item={item} />
        ))}
      </div>
    </div>
  );
}
